import { Component, OnInit, EventEmitter, Output, Inject, ElementRef } from '@angular/core';
import { NavigationExtras, ActivatedRoute } from '@angular/router';
import { NavController, MenuController } from '@ionic/angular/standalone';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { ContactService } from 'src/app/core/services/contact.service';
import { LocationContact } from 'src/app/shared/models/location';
import { Router } from '@angular/router';
import { PaymentService } from 'src/app/pages/billing/services/payment.service';
import { Transactions } from 'src/app/pages/billing/models/Transactions';
import { CommonModule } from '@angular/common';
import {
  IonIcon,
  IonLabel,
  IonBadge,
  IonSpinner
} from '@ionic/angular/standalone';
import { MyImageComponent } from '../../img-transform.component';
import { TranslateModule } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { business, chevronForwardOutline, chevronDownOutline, home, calendarNumberSharp, folderOpen, card, receipt, person, settings, notifications, lockClosed, power } from 'ionicons/icons';
@Component({
    selector: 'app-sidemenu',
    templateUrl: './sidemenu.component.html',
    styleUrls: ['./sidemenu.component.scss'],
    standalone: true,
    imports: [CommonModule, IonIcon, IonLabel, IonBadge, IonSpinner, MyImageComponent, TranslateModule]
})
export class SidemenuComponent implements OnInit {
  @Output() hideMenu = new EventEmitter();

  showLocations = false;
  currentUser: any;
  renderCurrentProfile: boolean = false;
  public locations: [LocationContact];
  transactions: Transactions[] = [];
  public switchingLocation = false;
  public selectedLocationId: number | null = null;

  constructor(
    private navController: NavController,
    private contactService: ContactService,
    private authService: AuthService,
    private router: Router,
    private paymentService: PaymentService,
    private menuController: MenuController,
    private elementRef: ElementRef,
  ) {
    addIcons({ business, chevronForwardOutline, chevronDownOutline, home, calendarNumberSharp, folderOpen, card, receipt, person, settings, notifications, lockClosed, power });
  }

  ngOnInit() {
    this.contactService.currentContact$
      .pipe(filter((val) => val?.id != null && val.id > 0))
      .subscribe((result) => {
        this.currentUser = result;
        this.getLocations();
        this.getPaymentList();
      });

    this.paymentService.transactions$.subscribe((transactions) => {
      this.transactions = transactions;
    });
  }
  

  getLocations() {
    if (this.currentUser.id != undefined) {
      this.contactService.getLocations().then((res) => {
        // Filter duplicates by locationId
        const uniqueLocations = res.filter((location, index, self) =>
          index === self.findIndex(l => l.locationId === location.locationId)
        );
        this.locations = uniqueLocations as [LocationContact];
      });
    }
  }

  async handleClickLocationList(location: LocationContact) {
    if (this.switchingLocation) return;

    this.switchingLocation = true;
    this.selectedLocationId = location.locationId;

    try {
      (await this.authService.changeLocation(location.locationId)).subscribe({
        next: async () => {
          const menuEl = this.elementRef.nativeElement.closest('ion-menu');
          if (menuEl) {
            await menuEl.close();
          }
          this.showLocations = false;
          this.switchingLocation = false;
          this.selectedLocationId = null;
          await this.router.navigateByUrl('/dashboard/tabs/home', { replaceUrl: true });
        },
        error: (err) => {
          console.error('Error changing location:', err);
          this.switchingLocation = false;
          this.selectedLocationId = null;
        }
      });
    } catch (err) {
      console.error('Error changing location:', err);
      this.switchingLocation = false;
      this.selectedLocationId = null;
    }
  }

  handleShowLocations() {
    this.showLocations = !this.showLocations;
  }

  async handleClickMenuList(action: string) {
    const menuEl = this.elementRef.nativeElement.closest('ion-menu');
    if (menuEl) {
      await menuEl.close();
    }
    await this.router.navigate([action]);
  }

  async handleClickMenuHome(action: string) {
    const menuEl = this.elementRef.nativeElement.closest('ion-menu');
    if (menuEl) {
      await menuEl.close();
    }
    const navigationExtras: NavigationExtras = {
      queryParams: { refresh: true },
    };

    await this.router.navigate(['/dashboard/tabs/home'], navigationExtras);
  }

  async handleClickOutRouter(routerParam: string) {
    const menuEl = this.elementRef.nativeElement.closest('ion-menu');
    if (menuEl) {
      await menuEl.close();
    }
    let navExtras: NavigationExtras = {
      queryParams: { type: routerParam },
    };
    await this.router.navigate(['/attendance'], navExtras);
  }

  handleClickPrivacy() {
    window.open('https://fitprotracker.com/privacy-policy');
  }

  handleClickLogout() {
    this.authService.doLogout();
  }

  getPaymentList() {
    if (this.currentUser.customerId != 0 && this.currentUser.customerId != undefined) {
      this.paymentService.getInvoicesPastDue().subscribe(
        (options: any) => {
          this.transactions = options.transactions;
        },
        (error) => {
          console.log(error);
        },
      );
    }
  }

  async handleClickNotification(action: string) {
    const menuEl = this.elementRef.nativeElement.closest('ion-menu');
    if (menuEl) {
      await menuEl.close();
    }
    let navExtras: NavigationExtras = {
      queryParams: { locationId: this.currentUser.locationId  },
    };
    await this.router.navigate([action], navExtras);
  }
}
